/* 🤖 this file was generated by svg-to-ts */
export const mgcIconBowlFilled: {
  name: 'bowl-filled';
  data: string;
} = {
  name: 'bowl-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.418 5.056c-.337.082-.585.226-.861.501-.293.292-.443.568-.517.948-.075.379-.031 3.262.057 3.815.312 1.955 1.199 3.705 2.563 5.06a9.174 9.174 0 0 0 3.006 1.978l.326.129.015.687c.013.651.02.698.125.926.147.315.455.624.764.767l.244.113h5.72l.244-.113c.309-.143.617-.452.764-.767.105-.228.112-.275.125-.926l.015-.687.326-.129a9.174 9.174 0 0 0 3.006-1.978c1.364-1.355 2.251-3.105 2.563-5.06.088-.553.132-3.436.057-3.815-.074-.38-.224-.656-.517-.948-.282-.282-.56-.438-.915-.512-.319-.067-16.832-.057-17.11.011"/></svg>`
};
